import { useState } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  if (!visible) return null;

  return (
    <>
      {/* Desktop */}
      <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-t border-gray-200/20 p-4 z-50 hidden md:block">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between gap-4">
            <div className="flex-1">
              <h4 className="text-gray-800 font-semibold mb-2">Consentement aux cookies</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Nous utilisons des cookies pour améliorer votre expérience sur notre site et analyser l&apos;utilisation de nos services.
                Conformément à la Loi fédérale sur la protection des données (LPD) suisse, vous pouvez accepter, refuser ou personnaliser vos préférences.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 min-w-fit">
              <button
                onClick={() => setVisible(false)}
                className="bg-[#00A8B5] hover:bg-[#008f9b] text-black font-semibold px-6 py-2 rounded-md transition-all duration-300 whitespace-nowrap text-sm cursor-pointer"
              >
                Accepter tout
              </button>
              <button
                onClick={() => setVisible(false)}
                className="border border-gray-300 text-gray-700 hover:bg-gray-100 font-semibold px-6 py-2 rounded-md transition-colors duration-300 whitespace-nowrap text-sm cursor-pointer"
              >
                Refuser
              </button>
              <button
                onClick={() => setModalOpen(true)}
                className="border border-[#00A8B5] text-[#00A8B5] hover:bg-[#00A8B5] hover:text-black font-semibold px-6 py-2 rounded-md transition-colors duration-300 whitespace-nowrap text-sm cursor-pointer"
              >
                Personnaliser
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200/60 shadow-[0_-2px_10px_rgba(0,0,0,0.05)] z-50 md:hidden rounded-t-xl">
        <div className="flex items-center gap-3 px-4 py-2.5">
          <p className="text-xs text-gray-600 leading-snug flex-1 line-clamp-2">
            Nous utilisons des cookies pour améliorer votre expérience sur notre site.
          </p>
          <div className="flex flex-col gap-1 flex-shrink-0">
            <button
              onClick={() => setVisible(false)}
              className="bg-[#00A8B5] hover:bg-[#008f9b] text-black text-xs font-semibold px-3 py-1.5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Accepter
            </button>
            <div className="flex gap-2 justify-center">
              <button
                onClick={() => setVisible(false)}
                className="text-gray-500 hover:text-gray-700 text-[10px] transition-colors cursor-pointer"
              >
                Refuser
              </button>
              <button
                onClick={() => setModalOpen(true)}
                className="text-[#00A8B5] hover:text-[#008f9b] text-[10px] transition-colors cursor-pointer"
              >
                Personnaliser
              </button>
            </div>
          </div>
        </div>
      </div>

      {modalOpen && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[60]">
          <div className="bg-gray-900 rounded-lg border border-[#8fbc8f]/30 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-semibold text-[#00A8B5]">Préférences des cookies</h3>
                <button
                  onClick={() => setModalOpen(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              <div className="space-y-6">
                <div className="border-b border-gray-700 pb-4">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-semibold text-white">Cookies essentiels</h4>
                    <div className="w-12 h-6 bg-[#00A8B5] rounded-full relative">
                      <div className="w-5 h-5 bg-white rounded-full absolute top-0.5 right-0.5"></div>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm">Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés.</p>
                </div>
                <div className="border-b border-gray-700 pb-4">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-semibold text-white">Cookies d&apos;analyse</h4>
                    <div className="w-12 h-6 bg-gray-600 rounded-full relative cursor-pointer">
                      <div className="w-5 h-5 bg-white rounded-full absolute top-0.5 left-0.5 transition-transform duration-200"></div>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm">Ces cookies nous aident à comprendre comment vous utilisez notre site web.</p>
                </div>
                <div className="border-b border-gray-700 pb-4">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-semibold text-white">Cookies marketing</h4>
                    <div className="w-12 h-6 bg-gray-600 rounded-full relative cursor-pointer">
                      <div className="w-5 h-5 bg-white rounded-full absolute top-0.5 left-0.5 transition-transform duration-200"></div>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm">Ces cookies sont utilisés pour vous proposer des publicités pertinentes.</p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 mt-6 pt-6 border-t border-gray-700">
                <button
                  onClick={() => { setModalOpen(false); setVisible(false); }}
                  className="bg-[#00A8B5] hover:bg-[#008f9b] text-black font-semibold px-6 py-3 rounded-md transition-all duration-300 whitespace-nowrap flex-1 cursor-pointer"
                >
                  Sauvegarder les préférences
                </button>
                <button
                  onClick={() => { setModalOpen(false); setVisible(false); }}
                  className="border border-[#00A8B5] text-[#00A8B5] hover:bg-[#00A8B5] hover:text-black font-semibold px-6 py-3 rounded-md transition-colors duration-300 whitespace-nowrap flex-1 cursor-pointer"
                >
                  Accepter tout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
